<template>
  <v-container
    v-if="$vuetify.breakpoint.mdAndUp"
    class="nav_container pa-0"
    :class="{ blackNav: showBlackNav, accountProfilePage, isDarkMode }"
  >
    <v-app-bar color="#fff0" elevation="0" class="nav">
      <!-- https://stackoverflow.com/questions/
        66809288/vuetify-how-to-fix-a-v-menu-at-given-position -->
      <div>
        <a v-if="showBlackNav" href="/">
          <v-toolbar-title class="headline text-uppercase flex_col">
            <img
              class="ml-4"
              :class="isAppClassic() ? 'navlogo' : 'navlogo-long'"
              :src="logoPath"
            />
          </v-toolbar-title>
        </a>
      </div>
      <v-spacer></v-spacer>
      <div>
        <a
          v-if="showBlackNav"
          href="#"
          class="navlink dark-mode-toggle align_center"
          title="Toggle dark mode"
          @click="toggleDarkMode"
        >
          <img
            class="dark-mode-toggle-img dark"
            :class="{ 'logged-out': !isLoggedIn }"
            :src="darkModeIconPath"
          />
        </a>
      </div>
      <div>
        <NumeraiTooltip v-if="nmrPrice" :text="nmrPriceTip">
          <a
            class="text_decoration_none nmr_link navlink"
            :class="{ dark: isDarkMode, blackNav: showBlackNav }"
            target="_blank"
            rel="noopener noreferrer"
            href="https://coinmarketcap.com/currencies/numeraire/"
            >1 NMR ≈ ${{
              (parseFloat(nmrPrice) && parseFloat(nmrPrice).toFixed(2)) || ' -'
            }}</a
          >
        </NumeraiTooltip>
      </div>
      <div>
        <v-menu offset-y left open-on-hover close-delay="300">
          <template v-slot:activator="{ on }">
            <span
              class="navlink pr-0"
              :class="{ dark: isDarkMode, blackNav: showBlackNav }"
              v-on="on"
            >
              Tournaments<v-icon
                small
                :color="
                  isDarkMode
                    ? 'var(--color-white)'
                    : !isDarkMode
                    ? '#5b5b5b'
                    : '#dddddd'
                "
                class="ma-0 pa-0"
                >mdi-menu-down</v-icon
              ></span
            >
          </template>
          <v-list :class="{ 'theme--dark': isDarkMode }">
            <v-list-item
              v-for="link in tournamentLinks"
              :key="link.title"
              :href="link.link"
              :target="link.target"
              :onclick="link.onclick"
            >
              <v-list-item-title class="dropdown-navlink">
                {{ link.title }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div v-if="!isAppCryptoSignals()">
        <a
          href="https://numerai.fund"
          class="navlink link"
          :class="{ dark: isDarkMode, blackNav: showBlackNav }"
          target="_blank"
        >
          Hedge Fund
        </a>
      </div>
      <a
        href="https://discord.gg/numerai"
        class="navlink link"
        :class="{ dark: isDarkMode, blackNav: showBlackNav }"
        target="_blank"
      >
        Discord
      </a>
      <a
        href="https://github.com/numerai/example-scripts"
        class="navlink link"
        :class="{ dark: isDarkMode, blackNav: showBlackNav }"
        target="_blank"
      >
        GitHub
      </a>
      <a
        href="https://forum.numer.ai/"
        class="navlink link"
        :class="{ dark: isDarkMode, blackNav: showBlackNav }"
        target="_blank"
      >
        Forum
      </a>
      <a
        :href="docsLinks[getTournamentNumber()]"
        class="navlink link"
        :class="{ dark: isDarkMode, blackNav: showBlackNav }"
        target="_blank"
      >
        Docs
      </a>
      <div>
        <v-menu v-if="isLoggedIn" offset-y left open-on-hover close-delay="200">
          <template v-slot:activator="{ on }">
            <span class="navlink pr-0" v-on="on">
              <v-icon
                :color="isDarkMode ? 'var(--color-white)' : '#5b5b5b'"
                class="ma-0 pa-0 mr-4"
                >mdi-account-circle</v-icon
              ></span
            >
          </template>
          <v-list>
            <router-link
              v-for="link in personalLinks"
              :key="link.title"
              :to="link.link"
              class="no_underline"
            >
              <v-list-item @click="() => false">
                <v-list-item-title class="dropdown-navlink">
                  {{ link.title }}
                </v-list-item-title>
              </v-list-item>
            </router-link>
            <v-list-item @click="logout">
              <v-list-item-title class="dropdown-navlink">
                Logout
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <router-link
        v-if="!isLoggedIn"
        to="/login"
        class="navlink link"
        tag="a"
        :class="{ dark: isDarkMode, blackNav: showBlackNav }"
        >Log In</router-link
      >
      <a
        v-if="!isLoggedIn"
        class="navlink link"
        :class="{
          dark: isDarkMode,
          blackNav: showBlackNav,
        }"
        @click="navSignUpPlausible"
        >Sign Up</a
      >
    </v-app-bar>
  </v-container>
  <v-container v-else class="pa-0">
    <v-app-bar color="#fff0" elevation="0" class="nav nav_container mobile">
      <a href="/" class="offset-left">
        <v-toolbar-title
          class="headline text-uppercase"
          style="display: flex; align-self: center"
        >
          <img
            class="ml-6"
            :class="isAppClassic() ? 'navlogo' : 'navlogo-long'"
            :src="logoPath"
          />
        </v-toolbar-title>
      </a>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon
        class="menu-button-icon"
        @click.stop="mobileDrawer = !mobileDrawer"
      />
    </v-app-bar>
    <v-navigation-drawer
      v-show="mobileDrawer"
      v-model="mobileDrawer"
      absolute
      floating
      temporary
      right
    >
      <v-list nav dense>
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
          <template v-for="(link, index) in mobileLinks">
            <a
              v-if="link.type === 'a'"
              :key="link.title + index"
              :href="link.link"
              :class="link.mobileClass"
            >
              <v-list-item :key="link.title" :class="link.mobileClass">
                {{ link.title }}
              </v-list-item>
            </a>
            <router-link
              v-else
              :key="link.title + index * mobileLinks.length"
              :to="link.link"
              tag="span"
            >
              <v-list-item :key="link.title">
                <span :class="link.mobileClass">
                  {{ link.title }}
                </span>
              </v-list-item>
            </router-link>
          </template>
          <span v-if="isLoggedIn" @click="logout">
            <v-list-item class="mobile-navlink"> Logout </v-list-item>
          </span>
          <a v-if="!isLoggedIn" href="/login" class="mobile-navlink">
            <v-list-item>
              Log In
            </v-list-item>
          </a>
          <a
            v-if="!isLoggedIn"
            class="mobile-navlink"
            @click="navSignUpPlausible"
          >
            <v-list-item> Sign Up </v-list-item>
          </a>
          <v-list-item class="mobile-navlink" @click="toggleDarkMode">
            <img
              class="dark-mode-toggle-img"
              :src="darkModeIconPath"
              :class="{
                dark: isDarkMode,
              }"
            />
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import NumeraiTooltip from '@/components/shared/NumeraiTooltip'
import {
  isAppClassic,
  isAppSignals,
  isAppCryptoSignals,
  isSoloPage,
  getTournamentNumber,
} from '@/lib/utils'
import * as Sentry from '@sentry/vue'

export default {
  components: {
    NumeraiTooltip,
  },
  data: () => ({
    mobileDrawer: false,
    group: null,
    nmrPriceTip: 'USD exchange rate provided by CoinMarketCap',
    msg: '',
    docsLinks: {
      8: 'https://docs.numer.ai/tournament/learn',
      11: 'https://docs.numer.ai/numerai-signals/signals-overview',
      12: 'https://docs.numer.ai/numerai-crypto/crypto-overview',
    },
  }),
  computed: {
    ...mapGetters(['isLoggedIn', 'username', 'nmrPrice', 'isDarkMode']),
    accountProfilePage() {
      return this.$route.name === 'account-profile-page'
    },
    logoPath() {
      if (isAppSignals()) {
        return require('@/assets/signals-logo-white.png')
      } else if (isAppCryptoSignals()) {
        return require('@/assets/cryptosignals-logo-white.png')
      } else {
        return require('@/assets/Numerai-Logo-Side-White.png')
      }
    },
    darkModeIconPath() {
      return require('@/assets/darkmode.svg')
    },
    showBlackNav() {
      return isSoloPage(this.$route.path)
    },
    tournamentLinks() {
      return [
        {
          title: 'Numerai',
          class: 'navlink link',
          mobileClass: 'mobile-navlink',
          link: 'https://numer.ai/tournament',
          type: 'a',
        },
        {
          title: 'Signals',
          class: 'navlink link color-signals',
          mobileClass: 'mobile-navlink',
          link: 'https://signals.numer.ai/tournament',
          type: 'a',
          onclick: `plausible('Signals Nudges', {props: {source: 'Navbar Nudge'}})`,
        },
        {
          title: 'Crypto',
          class: 'navlink link color-signals',
          mobileClass: 'mobile-navlink',
          link: 'https://crypto.numer.ai/tournament',
          type: 'a',
          onclick: `plausible('CryptoSignals Nudges', {props: {source: 'Navbar Nudge'}})`,
        },
      ]
    },
    personalLinks() {
      return [
        {
          title: 'View Profile',
          class: 'navlink',
          mobileClass: 'mobile-navlink',
          link: `/~${this.username}`,
          type: 'routerlink',
          loggedIn: true,
        },
        {
          title: 'Wallet',
          class: 'navlink',
          mobileClass: 'mobile-navlink',
          link: '/wallet',
          type: 'routerlink',
          loggedIn: true,
        },
        {
          title: 'Settings',
          class: 'navlink offset-right',
          mobileClass: 'mobile-navlink',
          link: '/account',
          type: 'routerlink',
          loggedIn: true,
        },
      ]
    },
    learnLinks() {
      const links = [
        {
          title: 'Docs',
          class: 'navlink',
          mobileClass: 'mobile-navlink',
          link: this.docsLinks[getTournamentNumber()],
          type: 'a',
          target: '_blank',
        },
        {
          title: 'Discord',
          class: 'navlink link',
          mobileClass: 'mobile-navlink',
          link: 'https://discord.gg/numerai',
          type: 'a',
          target: '_blank',
        },
        {
          title: 'Github',
          class: 'navlink link',
          mobileClass: 'mobile-navlink',
          link: 'https://github.com/numerai/example-scripts',
          type: 'a',
          target: '_blank',
        },
        {
          title: 'Forum',
          class: 'navlink link',
          mobileClass: 'mobile-navlink',
          link: 'https://forum.numer.ai/',
          type: 'a',
          target: '_blank',
        },
        {
          title: 'Fund',
          class: 'navlink link',
          mobileClass: 'mobile-navlink',
          link: 'https://numerai.fund',
          type: 'a',
          target: '_blank',
        },
      ]

      return links
    },
    links() {
      let shared = [
        {
          title: 'Home',
          class: 'navlink',
          mobileClass: 'mobile-navlink',
          link: '/home',
          type: 'a',
        },
      ]

      if (this.isLoggedIn) {
        shared = [
          ...shared,
          {
            title: 'Models',
            class: 'navlink',
            mobileClass: 'mobile-navlink',
            link: '/models',
            type: 'routerlink',
          },
          {
            title: 'Submissions',
            class: 'navlink',
            mobileClass: 'mobile-navlink',
            link: '/submissions',
            type: 'routerlink',
          },
          {
            title: 'Scores',
            class: 'navlink',
            mobileClass: 'mobile-navlink',
            link: '/scores',
            type: 'routerlink',
          },
          {
            title: 'Staking',
            class: 'navlink',
            mobileClass: 'mobile-navlink',
            link: '/staking',
            type: 'routerlink',
          },
        ]
      }

      shared.push({
        title: 'Leaderboard',
        class: 'navlink link',
        mobileClass: 'mobile-navlink',
        link: '/tournament',
        type: 'routerlink',
      })

      if (this.isAppCryptoSignals()) {
        shared.push({
          title: 'Meta Model',
          class: 'navlink link',
          mobileClass: 'mobile-navlink',
          link: '/meta-model',
          type: 'routerlink',
        })
      }
      shared.push({
        title: 'Season',
        class: 'navlink link',
        mobileClass: 'mobile-navlink',
        link: '/season',
        type: 'routerlink',
      })

      return [...shared]
    },
    mobileLinks() {
      return [
        ...this.links,
        ...this.tournamentLinks,
        ...this.learnLinks,
        ...this.personalLinks,
      ]
    },
  },
  watch: {
    group() {
      this.drawer = false
    },
  },
  methods: {
    isAppClassic,
    getTournamentNumber,
    isAppCryptoSignals,
    navSignUpPlausible() {
      window.plausible('Signup Page Visits', {
        props: { source: window.location.pathname + ' navbar' },
      })
      this.$router.push('/signup')
    },
    async logout() {
      try {
        await this.$client.logout()
      } catch (e) {
        console.error('Error logging out', e)
      }

      this.$store.dispatch('clearAuthInfo')
      this.$store.dispatch('clearAccountInfo')
      Sentry.configureScope(scope => scope.setUser(null))

      // swallow NavigationDuplicated route error
      this.$router.push('/tournament').catch(err => {
        this.msg = err
      })
      location.reload()
    },
    async toggleDarkMode() {
      await this.$store.dispatch('saveDarkMode', this.isDarkMode ? false : true)
    },
    goto(_route) {
      this.$router.push(_route)
    },
  },
}
</script>

<style scoped>
.navlogo {
  height: 1.6em;
}

.navlogo-long {
  height: 1.6em;
}

.navlink {
  color: #5b5b5b;
  text-decoration: none;
  cursor: pointer;
  font-family: var(--ui-font);
  font-weight: 500;
  transition-property: color;
  transition-duration: 0.2s;
  padding: 1em 1em;
  line-height: 1;
  height: 39px;
}

.navlink.dark {
  color: var(--color-white);
}

.navlink.blackNav,
.navlink.blackNav.dark {
  color: #dddddd;
  filter: none;
}

.account-icon:hover {
  color: #2e2e2e !important;
}

.account-icon.dark {
  filter: invert(100%);
}

.account-icon.dark:hover {
  color: var(--color-white) !important;
}

@media only screen and (min-width: 1264px) {
  .navlink {
    margin: 0 0 0 2em;
  }
}

.navlink:hover {
  transition-property: color;
  transition-duration: 0.2s;
  color: var(--color-primary);
  font-weight: 501;
}

.navlink.dark:hover,
.navlink.blackNav:hover {
  color: var(--color-white);
}

.dark-mode-toggle-img {
  font-size: 12px;
  height: 24px;
  width: 24px;
  margin-bottom: -2px;
  transition: opacity 0.2s;
  color: #5b5b5b;
}

.dark-mode-toggle-img.dark {
  filter: invert(100%);
}

.dark-mode-toggle-img.dark.blackNav {
  filter: invert(80%);
}

.dark-mode-toggle-img:hover {
  color: #2e2e2e;
}

.menu-button-icon {
  color: var(--color-tertiary) !important;
  padding-bottom: 2px;
}

.menu-button-icon:hover {
  cursor: pointer;
  color: var(--color-secondary) !important;
}

.dropdown-navlink {
  font-family: var(--ui-font);
  font-weight: 500;
  color: var(--color-secondary) !important;
  margin: 0 0 0 0px;
  text-decoration: none;
  cursor: pointer;
  transition-property: color;
  transition-duration: 0.2s;
  font-size: 1em;
}

.dropdown-navlink:hover {
  color: var(--color-primary) !important;
}

.mobile-navlink {
  font-size: 11px;
  text-decoration: none;
  cursor: pointer;
  font-family: var(--ui-font);
  font-weight: 500;
}

.nav {
  width: 100%;
  padding: 0 12px;
  margin: 0;
  height: auto !important;
}

@media screen and (max-width: 820px) {
  .nav {
    padding: 12px 0;
  }
}

.offset-right {
  margin-right: -16px;
}

.offset-left {
  margin-left: -16px;
}

.no_underline {
  text-decoration: none !important;
}

.nmr_link {
  font-weight: 500;
  color: #5b5b5b;
}

.nmr_link.blackNav {
  color: #dddddd;
}

.nmr_link:hover {
  text-decoration: underline;
}

.nav_container {
  background-color: #fff0;
  max-width: 100% !important;
}

.nav_container.accountProfilePage {
  background-color: var(--paper-background-color);
}

.nav_container.accountProfilePage.isDarkMode {
  background-color: #000000;
}

.nav_container.mobile,
.nav_container.blackNav {
  background-color: #0e0f0f !important;
  box-shadow: 0px -2px 15px 0 #0008;
}

.darkmode .nav_container {
  background-color: var(--background-color) !important;
}

.darkmode .nav_ .dark-mode-toggle {
  display: flex;
}
</style>
